import { defineStore } from 'pinia';
import { LAYOUTS } from '@/constants';

export const useLayoutStore = defineStore('layout', {
	state: () => ({
		current_layout: LAYOUTS.EDITOR.key,
	}),
	actions: {
		setLayout(layout_key) {
			this.current_layout = layout_key;
		},
	},
});
